import React, { useState } from "react";
import "./Activities.css";

const Activities = () => {
  const [activeTab, setActiveTab] = useState("Sports");

  const activityContent = {
    Sports: {
      title: "🏅 Sports & Fitness",
      desc: "From cricket to yoga, our school provides a wide range of sports facilities. Students are encouraged to participate in athletics, team sports, and fitness programs that foster discipline, teamwork, and resilience.",
      img: "https://kkblossomschool.org/KKBlossomsWebsite/uploads/Sport-img1.webp",
    },

    Arts: {
      title: "🎨 Arts & Creativity",
      desc: "We believe in nurturing creativity. Our art studio is a space for students to express themselves through painting, sketching, and sculpture while developing aesthetic skills and imagination.",
      img: "https://kkblossomschool.org/KKBlossomsWebsite/uploads/school-img6.jpg",
    },

    Music: {
      title: "🎵 Music & Dance",
      desc: "Music and dance form an integral part of our curriculum. From classical to contemporary, students engage in learning instruments, singing, and performing on stage with confidence.",
      img: "https://kkblossomschool.org/KKBlossomsWebsite/uploads/music-img.jpg",
    },

    Clubs: {
      title: "🤝 Clubs & Societies",
      desc: "A variety of clubs like Science Club, Debate Club, and Eco Club empower students to pursue their interests, develop leadership skills, and work collaboratively towards meaningful projects.",
      img: "https://kkblossomschool.org/KKBlossomsWebsite/uploads/school-img7.jpg",
    },

    Events: {
      title: "🎉 Annual Events & Celebrations",
      desc: "Our vibrant campus celebrates cultural festivals, annual day functions, exhibitions, and competitions, making learning a joyful and memorable experience.",
      img: "https://kkblossomschool.org/KKBlossomsWebsite/uploads/Goup-img.png",
    },

    SocialScience: {
      title: "🌱 Social Science Activity",
      desc: "Innovating today: converting natural resources into renewable alternatives. This activity encouraged students to explore sustainable solutions and understand how natural resources can be transformed into renewable alternatives for a better future.",
      img: "https://kkblossomschool.org/KKBlossomsWebsite/uploads/School-5.png",
    },

    Orientation: {
      title: "🎓 Orientation Session 2026 – 2027",
      desc: "Stepping into a new academic journey. The orientation session welcomed students to the new academic year, introducing them to school values, learning opportunities, and inspiring them to begin their journey with enthusiasm and confidence.",
      img: "https://kkblossomschool.org/KKBlossomsWebsite/uploads/School-6.png",
    },
  };

  return (
    <div className="activities-container">
      {/* Hero Section */}
      <header className="activities-hero">
        <div className="hero-container">
          <h1>Student Activities</h1>
          <p>
            Building confidence, creativity, and teamwork through engaging
            activities and experiences.
          </p>
        </div>
      </header>

      {/* Tabs Section */}
      <div className="tabs">
        {Object.keys(activityContent).map((tab) => (
          <button
            key={tab}
            className={activeTab === tab ? "active" : ""}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </button>
        ))}
      </div>

      {/* Content Section */}
      <div className="tab-content">
        <h2 className="sub-title">
          {activityContent[activeTab].title}
        </h2>

        <p>{activityContent[activeTab].desc}</p>

        <img
          src={activityContent[activeTab].img}
          alt={activeTab}
          loading="lazy"
        />
      </div>

      {/* Gallery Section */}
      <section className="gallery">
        <h2>📸 Glimpses of Activities</h2>

        <div className="gallery-grid">
          <img
            src="https://kkblossomschool.org/KKBlossomsWebsite/uploads/Sport-img.webp"
            alt="Sports"
            height="200"
            width="350"
          />

          <img
            src="https://kkblossomschool.org/KKBlossomsWebsite/uploads/school-img5.jpg"
            alt="Students"
            height="200"
            width="350"
          />

          <img
            src="https://kkblossomschool.org/KKBlossomsWebsite/uploads/school-img6.jpg"
            alt="Group Activity"
            height="200"
            width="350"
          />

          <img
            src="https://kkblossomschool.org/KKBlossomsWebsite/uploads/school-img7.jpg"
            alt="Clubs"
            height="200"
            width="350"
          />
        </div>
      </section>
    </div>
  );
};

export default Activities;